import * as React from "react";
import {
  Text,
  View,
  Image,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Platform,
  KeyboardAvoidingView
} from "react-native";
import { ScrollView, TextInput } from "react-native-gesture-handler";
import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import FooterBarWide from "../../components/footerBarWide";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import { useSelector } from "react-redux";
import { FontAwesome } from "@expo/vector-icons";
import { withdrawlRequest } from "../../redux/actions/TransactionActions";
import BackButton from "../../components/BackButton";
import GenericButton from "../../components/GenericButton.js";



export default function ManageFund() {
  const navigation = useNavigation();
  const win = Dimensions.get("window");
  const [errorMsg, onErrorMsg] = React.useState("");
  const trySignUp = async (accountName, BSB, accountNumber, balance) => {
    const accountObj = {
      accountName: 0,
      BSB: 0,
      accountNumber: 0,
      amount: 0
    }
    let err = "FALSE"
    try {
      if (accountName != "") {
        accountObj.accountName = accountName
      }
      else {
        onErrorMsg("Please enter an account name");
        err = "TRUE"
        return
      };
      if (BSB != "") {
        accountObj.BSB = BSB
      } else {
        onErrorMsg("Please enter a BSB number");
        err = "TRUE"
        return
      };
      if (BSB.length != 6) {
        onErrorMsg("BSB number must be 6 digits")
        err = "TRUE"
        return
      };
      if (accountNumber != "") {
        accountObj.accountNumber = accountNumber
      } else {
        onErrorMsg("Please enter an account number");
        err = "TRUE"
        return
      };
      if (accountNumber.length > 10) {
        onErrorMsg("Account number should be no more than 10 digits")
        err = "TRUE"
        return
      };
      if (balance === "") {
        onErrorMsg("Please enter a withdrawal amount");
        err = "TRUE";
        return;
      } else if (balance < 10) {
        onErrorMsg("Minimum withdrawal is $10");
        err = "TRUE";
        return;
      } else if (balance > setBalance) {
        onErrorMsg("Insufficient funds");
        err = "TRUE"
        return;
      } else {
        accountObj.amount = balance
      }
      if (err != "TRUE") {
        withdrawlRequest(accountObj);
        navigation.navigate("WithdrawalNotificationConfirm");
      }
    }
    catch (error) {
      onErrorMsg(error.message);
    }
  }
  var setBalance = useSelector((state) => state.user.userData.balance.amountInvestedConfirmed) != undefined ? useSelector((state) => state.user.userData.balance.amountInvestedConfirmed) : 0;
  
  const withdrawnAmount = useSelector((state) => state.user.userAmountWithdrawn);

  var setBalance = setBalance - withdrawnAmount;
  
  
  //var setBalance = 100;
  const [accountName, onChangeAccountNameText] = React.useState("");
  const [BSB, onChangeBSBText] = React.useState("");
  const [accountNumber, onChangeAccountNumberText] = React.useState("");
  const [balance, onChangebalanceText] = React.useState("");
  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={styles.container}>
      <View style={GlobalStyles.containerW}>
        <ScrollView style={styles.scrollArea}>
          {win.width > 768 ? (
            <View style={GlobalStyles.fullHeaderBarY}>
              <MenuBar data="4" />
              <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
                <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
                  <View style={GlobalStyles.headerTextYellowForweb}>
                    <View style={GlobalStyles.backIconContainerForWeb} >
                      <BackButton />
                    </View>
                    <View>
                      <Text style={GlobalStyles.headingStyle}>Make a Withdrawal</Text>
                      <Text style={GlobalStyles.subheaderStyleWeb}>Saving with Aura is easy and so is cashing out.</Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          ) : (
            <View>
              <StatusBar data="BM" />
              <View style={GlobalStyles.fullHeaderBarW}>
                <View style={GlobalStyles.headerContainerKL}>
                  <View style={GlobalStyles.headerText}>
                    <Text style={GlobalStyles.headingStyle}>Make a Withdrawal</Text>
                    <Text style={GlobalStyles.subheaderStyleWeb}>Saving with Aura is easy and so is cashing out.
                    </Text>
                  </View>
                </View>
              </View>
            </View>)}
          <View style={GlobalStyles.bodyContainer}>
            <View style={styles.bodySectionContainer}>
              <View style={styles.formContainer}>
                <Text style={styles.textSectionStyle}>
                  All money withdrawn from your Aura Account will be paid into your nominated bank account. ($10 minimum) Please allow 2-5 business days.
                </Text>
                {setBalance < 10 ? <View style={styles.inputBoxFaded}>
                  <Text style={styles.textFaded}>Nearly there… a few more purchases</Text>
                </View> :
                  <View style={styles.formStyle}>
                    <Text style={[GlobalStyles.formLabelTextInvest, { paddingTop: 10 }]}>
                      Account Name*
                    </Text>
                    <View style={styles.inputBox}>
                      <TextInput
                        placeholder="Enter the account name"
                        style={styles.textInput}
                        underlineColorAndroid="transparent"
                        value={accountName}
                        onChangeText={(text) => onChangeAccountNameText(text)}
                      />
                    </View>
                    <Text style={[GlobalStyles.formLabelTextInvest, { paddingTop: 10 }]}>
                      BSB*
                    </Text>
                    <View style={styles.inputBox}>
                      <TextInput
                        placeholder="BSB"
                        style={styles.textInput}
                        underlineColorAndroid="transparent"
                        value={BSB}
                        onChangeText={(text) => onChangeBSBText(text)}
                        keyboardType="numeric"
                      />
                    </View>
                    <Text style={[GlobalStyles.formLabelTextInvest, { paddingTop: 10 }]}>
                      Account Number*
                    </Text>
                    <View style={styles.inputBox}>
                      <TextInput
                        placeholder="Account Number"
                        style={styles.textInput}
                        underlineColorAndroid="transparent"
                        value={accountNumber}
                        onChangeText={(text) => onChangeAccountNumberText(text)}
                        keyboardType="numeric"
                      />
                    </View>
                    <Text style={[GlobalStyles.formLabelTextInvest, { paddingTop: 10 }]}>
                      {"Amount* ( $" + setBalance.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + " Available )"}
                    </Text>
                    <View style={styles.inputBoxAmount}>
                      <FontAwesome
                        name={"dollar"}
                        size={16}
                        color="#998fa2"
                        style={styles.iconStyle}
                      />
                      <TextInput
                        placeholder={"Enter amount"}
                        style={styles.textInput}
                        underlineColorAndroid="transparent"
                        value={balance}
                        onChangeText={(text) => onChangebalanceText(text)}
                        keyboardType="numeric"
                      />
                    </View>
                  </View>}

                <Text style={styles.TextStyleError}>{errorMsg}</Text>
                <View style={styles.buttonContainer}>
                  <GenericButton
                    buttonText='BACK'
                    onPress={() => navigation.goBack()}
                    buttonColor={null}
                    buttonWidth={105}
                    borderWidth={1}
                    borderColor="#000000"
                  />
                  {setBalance < 10 ? null :
                    // <TouchableOpacity
                    //   style={styles.SubmitButtonStyleContinue}
                    //   activeOpacity={0.5}
                    //   onPress={() => {
                    //     trySignUp(
                    //       accountName,
                    //       BSB,
                    //       accountNumber,
                    //       balance
                    //     );
                    //   }}
                    // >
                    //   <Text style={styles.TextStyle}>CONFIRM</Text>
                    // </TouchableOpacity>
                    <GenericButton
                      buttonText='CONFIRM'
                      onPress={() => {
                        trySignUp(
                          accountName,
                          BSB,
                          accountNumber,
                          balance
                        );
                      }}
                      buttonWidth={105}
                    />
                  }
                </View>
              </View>
              {/* </View> */}
              <View style={GlobalStyles.webFooter}>
                {/* {win.width > 768 ? <FooterBarWide /> : null} */}
              </View>
              {/* </View> */}
            </View>
          </View>
        </ScrollView>
        <View style={GlobalStyles.webFooter}>
          {win.width > 768 ? <FooterBarWide /> : null}
        </View>
      </View>
    </KeyboardAvoidingView>
  );
}
const margin = Platform.OS != "web" ? 0 : 3
const styles = StyleSheet.create({
  iconStyle: {
    alignSelf: "center",
    paddingRight: 2,
    paddingTop: -15,
    marginBottom: margin
  },
  TextStyleError: {
    paddingTop: 20,
  },
  container: {
    flex: 1,
  },
  bodyContainerT: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    justifyContent: 'center',
  },
  formStyle: {
    flexDirection: "column",
  },
  inputBox: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#FFFF",
    marginTop: 8,
    justifyContent: "center",
    borderWidth: 1,
    borderRadius: 5,
    borderColor: "#C6C6C6",
  },
  inputBoxAmount: {
    paddingLeft: 10,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#FFFF",
    marginTop: 8,
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "row",
    borderWidth: 1,
    borderRadius: 5,
    borderColor: "#C6C6C6",
  },
  inputBoxFaded: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#DDD",
    marginTop: 50,
    justifyContent: "center",
    width: "100%",
    borderWidth: 1,
    borderRadius: 5,
    borderColor: "#C6C6C6",
  },
  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
    borderColor: "#CCCCCC",
    fontFamily: "montserrat-medium",
    fontSize: 11,
    textAlign: "left",
    paddingTop: 20,
    paddingBottom: 5,
  },
  buttonContainer: {
    flexDirection: "row",
    width: "100%",
    alignContent: "space-between",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 15,
    justifyContent: "space-evenly",
  },
  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },
  TextStyleHeader: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },
  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    paddingTop: 10,
  },
  formContainer: {
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 55,
    alignSelf: "center",
  },
  SubmitButtonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },
  SubmitButtonStyleBack: {
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFC72C",
    borderColor: "#000000",
    flex: 1,
    borderWidth: 1,
    color: "#000000",
    height: 60,
    justifyContent: 'center',
  },
  StandAloneSubmitButtonStyleBack: {
    paddingTop: 22,
    paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxWidth: "45%",
    alignContent: "center",
  },
  SubmitButtonStyleContinue: {

    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    justifyContent: 'center',
  },
  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: 'none'
      }
    }),
    borderColor: "#CCCCCC",
    height: 35,
    fontSize: 14,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
  },
  textFaded: {
    height: 35,
    fontSize: 14,
    paddingRight: 10,
    paddingTop: 7,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
    color: "#666666",
  },

  optionIconContainer: {
    flex: 2,
    alignSelf: "center",
  },
  optionTextContainer: {
    flex: 6,
    alignSelf: "center",
  },
  optionSubtextContainer: {
    flex: 6,
    alignSelf: "center",
  },
  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "left",
  },
  optionSubtext: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "right",
  },
  containerBox: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    marginBottom: 15,
  },
  containerA: {
    alignItems: "center",
    paddingTop: 20,
    paddingBottom: 20,
  },
  logoText: {
    paddingTop: 20,
  },
  smallLogo: {
    width: 107,
    height: 60,
    resizeMode: "contain",
  },
});
